<div class="trust-signals-editor">
  <div cdkDropList (cdkDropListDropped)="onDrop($event)" class="trust-signals-editor__list">
    @for (signalForm of signals.controls; track signalForm.get('id')?.value; let i = $index) {
      <div cdkDrag class="trust-signals-editor__row">
        <pdq-drag-and-drop cdkDragHandle spacing="tight"></pdq-drag-and-drop>
        <pdq-iconpicker
          [presetIconUrls]="presetIconUrls"
          [presetIconLabels]="presetIconLabels"
          [iconUrl]="iconUrlValue(getSignalAt(i))"
          [customIconUrl]="customIconUrlValue(getSignalAt(i))"
          [supportsCustomUpload]="true"
          [variant]="'popover'"
          (iconUrlChange)="onIconUrlChange(getSignalAt(i), $event)"
          (uploadCustomRequested)="onUploadCustomRequested(getSignalAt(i))"
          (removeCustomRequested)="onRemoveCustomRequested(getSignalAt(i))">
        </pdq-iconpicker>
        <pdq-input
          class="trust-signals-editor__text"
          [formControl]="getSignalAt(i).get('text')"
          placeholder="e.g., Free returns within 30 days">
        </pdq-input>
        <button
          type="button"
          class="trust-signals-editor__trash-btn"
          [disabled]="signalsCount <= 1"
          (click)="removeSignal(i); $event.stopPropagation()"
          aria-label="Remove trust signal">
          <pdq-icon icon="trash" size="small" color="var(--error-default)"></pdq-icon>
        </button>
      </div>
    }
  </div>
  <div class="trust-signals-editor__footer">
    @if (canAddSignal) {
      <button type="button" class="trust-signals-editor__add-btn" (click)="addSignal()">
        <pdq-icon icon="Plus" size="small" color="var(--secondary-default)"></pdq-icon>
        <span>Add trust signal</span>
      </button>
    }
    <span class="trust-signals-editor__counter">{{ signalsCount }} of {{ maxSignals }} signals</span>
  </div>
</div>
